export class SetSpinnerVisibility {
  static readonly type = '[Spinner] Set';

  constructor(
    public visibility: boolean
  ) {}
}
